import axios from "axios";
import { GET_FEEDBACK_FORM, RESPONSE_SUBMITTED, UPLOAD_REVIEW_VERIFICATION } from "../constants/response";

export const getFormForResponse = (data) => async (dispatch) => {
  let headers = {
    "Content-Type": "application/json",
  };

  try {
    let response = await axios.get(
      `${process.env.REACT_APP_API_URL}/feedbacks/apiv2/response/feedback-form/`,
      { headers, params: data }
    );

    if (response.status === 200) {
      const payload = response.data || {};
      const formData = payload.data || {};

      // Ensure review flow config travels with the form for the thank-you screen.
      const reviewFlow = payload.review_flow || formData.review_flow;
      const defaultReviewFlow =
        payload.default_review_flow || formData.default_review_flow;

      return dispatch({
        type: GET_FEEDBACK_FORM,
        data: {
          ...formData,
          ...(reviewFlow ? { review_flow: reviewFlow } : {}),
          ...(defaultReviewFlow
            ? { default_review_flow: defaultReviewFlow }
            : {}),
        },
        store: payload.store,
        feedbacker: payload.feedbacker,
        feedback: payload.feedback || null,
        ffAction: payload.action,
      });
    }
    if (response.status === 220) {
      const payload = response.data || {};
      const formData = payload.data || {};
      const reviewFlow = payload.review_flow || formData.review_flow;
      const defaultReviewFlow =
        payload.default_review_flow || formData.default_review_flow;

      dispatch({
        type: GET_FEEDBACK_FORM,
        data: {
          ...formData,
          ...(reviewFlow ? { review_flow: reviewFlow } : {}),
          ...(defaultReviewFlow
            ? { default_review_flow: defaultReviewFlow }
            : {}),
        },
        store: payload.store,
        feedbacker: payload.feedbacker,
        forceThankyouScreen: true,
      });
      return response;
    }
  } catch (error) {
    throw error;
  }
};

export const getTemplateFeedbackForm = (data) => async (dispatch) => {
  let headers = {
    "Content-Type": "application/json",
  };

  try {
    let response = await axios.get(
      `${process.env.REACT_APP_API_URL}/feedbacks/apiv2/templates/get-template-form/?template_form_id=${data}`,
      { headers }
    );

    if (response.status === 200) {
      const payload = response.data || {};
      const formData = payload.data || {};
      const reviewFlow = payload.review_flow || formData.review_flow;
      const defaultReviewFlow =
        payload.default_review_flow || formData.default_review_flow;

      return dispatch({
        type: GET_FEEDBACK_FORM,
        data: {
          ...formData,
          ...(reviewFlow ? { review_flow: reviewFlow } : {}),
          ...(defaultReviewFlow
            ? { default_review_flow: defaultReviewFlow }
            : {}),
        },
        store: payload.store,
      });
    }
  } catch (error) {
    throw error;
  }
};

export const sendFormOTP = (formID, data) => async (dispatch) => {
  let headers = {
    "Content-Type": "application/json",
  };

  try {
    let response = await axios.post(
      `${process.env.REACT_APP_API_URL}/feedbacks/apiv3/forms/${formID}/send-otp/`,
      data,
      { headers }
    );

    if (response.status === 200) {
      return response
    }
  } catch (error) {
    throw error;
  }
};

export const verifyFormOTP = (formID, data) => async (dispatch) => {
  let headers = {
    "Content-Type": "application/json",
  };

  try {
    let response = await axios.post(
      `${process.env.REACT_APP_API_URL}/feedbacks/apiv3/forms/${formID}/verify-otp/`,
      data,
      { headers }
    );

    if (response.status === 200) {
      return response
    }
  } catch (error) {
    throw error;
  }
};

export const submitResponseOfAForm = (data) => async (dispatch) => {
  let headers = {
    "Content-Type": "application/json",
  };

  try {
    let response = await axios.post(
      `${process.env.REACT_APP_API_URL}/feedbacks/apiv2/feedback-api/`,
      data,
      { headers }
    );

    if (response.status === 201) {
      dispatch({
        type: RESPONSE_SUBMITTED,
        data: response.data,
      })
      return response
    }
  } catch (error) {
    throw error;
  }
};

export const verifyEmployeePin = (formID, data) => async (dispatch) => {
  let headers = {
    "Content-Type": "application/json",
  };

  console.log("data", data)

  try {
    let response = await axios.post(
      `${process.env.REACT_APP_API_URL}/feedbacks/apiv3/forms/${formID}/verify-employee-pin/`,
      data,
      { headers }
    );

    if (response.status === 200) {
      return response
    }
  } catch (error) {
    throw error;
  }
};

export const handleRedirection = (feedbackID, data) => async (dispatch) => {
  let headers = {
    "Content-Type": "application/json",
  };

  try {
    let response = await axios.post(
      `${process.env.REACT_APP_API_URL}/feedbacks/apiv3/feedbacks/${feedbackID}/redirect/`,
      data,
      { headers }
    );

    if (response.status === 200) {
      return response
    }
  } catch (error) {
    throw error;
  }
};

export const uploadReviewScreenshot = async (feedbackID, file) => {
  try {
    let formData = new FormData();
    formData.append("feedback_id", feedbackID);
    formData.append("image", file);

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/reviews/upload_review_screenshot/`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
